// FeatureId naming convention: {module || 'app'}.{short-name}

export enum AppFeatureId {
  Cartography = 'app.cartography',
  NewDesign = 'app.new-design',
}
